import { render, staticRenderFns } from "./BaseUser.vue?vue&type=template&id=19c171ce&scoped=true"
import script from "./BaseUser.vue?vue&type=script&lang=js"
export * from "./BaseUser.vue?vue&type=script&lang=js"
import style0 from "./BaseUser.vue?vue&type=style&index=0&id=19c171ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c171ce",
  null
  
)

export default component.exports